import React from 'react';
import { useTranslation } from 'react-i18next';

const LeaveConfirmation = ({ onConfirm, onCancel }) => {
    const { t } = useTranslation();

    return (
        <div className={"preload-message"}>
            <div className="confirmation-box" style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '400px',
                textAlign: 'center'
            }}>
                <img src="/images/crewcart.png" width={150} className="crewcart-logo-black" style={{
                    marginBottom: '20px'
                }} />

                <h3 style={{ marginBottom: '20px' }}>
                    {t('leaveConfirmation.title')}
                </h3>

                <p style={{ marginBottom: '20px' }}>
                    {t('leaveConfirmation.message')}
                </p>

                <div className="button-container" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px'
                }}>
                    <button
                        onClick={onConfirm}
                        className="btn btn-danger rounded-0"
                    >
                        {t('leaveConfirmation.confirmButton')}
                    </button>
                    <button
                        onClick={onCancel}
                        className="btn btn-primary rounded-0"
                    >
                        {t('leaveConfirmation.cancelButton')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LeaveConfirmation;
